export const getDays = (date) => {
	const today = new Date();
	const date1 = new Date(date);
	const times = today.getTime() - date1.getTime();
	return Math.ceil(times / (1000 * 3600 * 24));
}
